import { Stack, Typography } from "@mui/material";
import levelRightBg from "../assets/levelRightBg.webp";
import { Button, Input } from "components";
import { CopyWebhookUrlAndSecret } from "./CopyWebhookUrlAndSecret";
import { forwardRef, useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  useCreateLevelAuthConfig,
  useGetLevelAuthConfig,
  useUpdateLevelAuthConfig,
} from "controller";
import { addMixpanelEvent } from "utilz/helpers";
export const ConnectLevelAccount = ({
  apiKey,
  setApiKey,
}: {
  apiKey: string;
  setApiKey: any;
}) => {
  const { data: levelAuthConfig } = useGetLevelAuthConfig();
  const {
    mutateAsync: createLevelAuthConfig,
    isLoading: isCreateLevelAuthConfigLoading,
  } = useCreateLevelAuthConfig();
  const {
    mutateAsync: updateLevelAuthConfig,
    isLoading: isUpdateLevelAuthConfigLoading,
  } = useUpdateLevelAuthConfig();
  const [errorMessage, setErrorMessage] = useState("");
  const onGenerateWebhookSecret = async () => {
    if (apiKey) {
      try {
        if (levelAuthConfig?.data?.api_key) {
          await updateLevelAuthConfig({
            api_key: apiKey,
            webhook_url: levelAuthConfig?.data?.webhook_url,
            webhook_secret: levelAuthConfig?.data?.webhook_secret,
            board: levelAuthConfig?.data?.board,
          });
        } else {
          await createLevelAuthConfig(apiKey);
          addMixpanelEvent({
            event: "level_connection_success",
          });
        }
        toast.success("Webhook secret generated successfully");
      } catch (error: any) {
        toast.error(error?.message || "Failed to generate webhook secret");
      }
    } else {
      setErrorMessage("API key is required");
    }
  };
  useEffect(() => {
    if (errorMessage && apiKey) {
      setErrorMessage("");
    }
  }, [apiKey]);
  return (
    <Stack flex={1} alignItems={"center"}>
      <Stack gap="24px" p="32px" width="100%">
        <Stack gap="16px">
          <Typography variant="body-medium" color="lightBg.low">
            Enter your Level RMM account details to start the integration.
          </Typography>
        </Stack>
        <Input
          label="Level RMM API key"
          placeholder="Enter API key"
          name="level_api_key"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          errorMessage={errorMessage}
        />
        {/* border-color hard-coded 👇 - add it to theme later */}
        {levelAuthConfig?.data?.api_key === apiKey &&
          levelAuthConfig?.data?.webhook_url &&
          levelAuthConfig?.data?.webhook_secret && (
            <CopyWebhookUrlAndSecret
              webhookUrl={levelAuthConfig?.data?.webhook_url}
              secretKey={levelAuthConfig?.data?.webhook_secret}
            />
          )}
        {(!levelAuthConfig?.data?.api_key ||
          !levelAuthConfig?.data?.webhook_secret ||
          !levelAuthConfig?.data?.webhook_url ||
          levelAuthConfig?.data?.api_key !== apiKey) && (
          <Button
            sx={{
              alignSelf: "flex-start",
            }}
            onClick={onGenerateWebhookSecret}
            loading={
              isCreateLevelAuthConfigLoading || isUpdateLevelAuthConfigLoading
            }
            // disabled={!apiKey}
          >
            Generate Webhook Secret
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
